import { useReactOidc } from "@axa-fr/react-oidc-context"
import notAuthImg from "@src/assets/images/pages/not-authorized.svg"

import "@styles/base/pages/page-misc.scss"
import { useEffect } from "react"

const Authenticating = () => {
  const { logout } = useReactOidc()

  useEffect(() => {
    setTimeout(() => {
      logout()
    }, 500)
  }, [])

  return (
    <div className="misc-wrapper">
      <div className="misc-inner p-2 p-sm-3">
        <div className="w-100 text-center">
          <h2 className="mb-1">Processing! 🔐</h2>
          <p className="mb-2"></p>
          <img
            className="img-fluid"
            src={notAuthImg}
            alt="Not authorized page"
          />
        </div>
      </div>
    </div>
  )
}
export default Authenticating
